// Travel Nosh — theme JS (v2)
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };

  function $(s, ctx) { return (ctx || document).querySelector(s); }
  function $$(s, ctx) { return Array.from((ctx || document).querySelectorAll(s)); }

  function fetchCart() {
    return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function updateCartBadge(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var sub = $('[data-cart-subtotal]');
    if (sub && cart.total_price !== undefined) {
      sub.textContent = formatMoney(cart.total_price);
    }
  }

  function formatMoney(cents) {
    // very lightweight USD fallback; Shopify checkout is the source of truth
    return '$' + (cents / 100).toFixed(2);
  }

  // ===== Cart drawer =====
  var drawer = $('[data-cart-drawer]');
  function openDrawer() { if (!drawer) return; drawer.setAttribute('aria-hidden', 'false'); drawer.classList.add('is-open'); document.body.classList.add('no-scroll'); }
  function closeDrawer() { if (!drawer) return; drawer.setAttribute('aria-hidden', 'true'); drawer.classList.remove('is-open'); document.body.classList.remove('no-scroll'); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-close]')) { closeDrawer(); }
    if (e.target.closest('[data-cart-open]')) {
      // Only intercept if the drawer exists; otherwise let the link navigate to /cart
      if (drawer) { e.preventDefault(); openDrawer(); refreshDrawer(); }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closePopup(); closeMobileNav(); }
  });

  // v11: rebuild item list — refreshDrawer now populates [data-cart-drawer-items]
  // from the /cart.js response so items appear after AJAX add-to-cart on an
  // initially-empty cart (Liquid only renders items that exist at page load time).
  function escHtml(s) {
    return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  // v25: Shopify keeps split cart lines (one line per unit) once the WELCOMENOSH
  // discount applies, so the drawer groups lines by variant and always re-reads
  // /cart.js after a change instead of editing its own numbers (launch QA finding 1).
  var MN_BONUS_VARIANT = 67686526877805;
  function groupLines(items) {
    var groups = [], byVariant = {};
    items.forEach(function (item) {
      var g = byVariant[item.variant_id];
      if (!g) {
        g = { item: item, isBonus: item.variant_id === MN_BONUS_VARIANT, keys: [], qty: 0, total: 0 };
        byVariant[item.variant_id] = g;
        groups.push(g);
      }
      g.keys.push(item.key);
      g.qty += item.quantity;
      g.total += item.final_line_price;
    });
    return groups;
  }
  function cartChange(key, qty) {
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart change failed');
      return r.json();
    });
  }
  function refreshDrawer() {
    if (!drawer) return;
    fetchCart().then(function (cart) {
      updateCartBadge(cart);
      var empty = $('[data-cart-drawer-empty]', drawer);
      if (empty) empty.hidden = cart.item_count > 0;
      var checkout = $('.cart-drawer__checkout', drawer);
      if (checkout) checkout.hidden = cart.item_count === 0;
      var list = $('[data-cart-drawer-items]', drawer);
      if (!list) return;
      if (cart.item_count === 0) { list.innerHTML = ''; return; }
      var html = '';
      groupLines(cart.items).forEach(function (g, i) {
        var item = g.item;
        var imgUrl = item.featured_image && item.featured_image.url ? item.featured_image.url : (item.image || null);
        var imgHtml = imgUrl
          ? '<img src="' + escHtml(imgUrl) + '" alt="' + escHtml(item.product_title) + '" class="cart-drawer__thumb" loading="lazy">'
          : '';
        var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        var titleLine = escHtml(item.product_title) + (variantTitle ? ' <small>' + escHtml(variantTitle) + '</small>' : '');
        var controls = g.isBonus
          ? '<p class="cart-drawer__gift">Free with your first order</p>' +
            '<button type="button" class="cart-drawer__remove" data-cart-remove-bonus>Remove</button>'
          : '<div class="cart-drawer__qty">' +
            '<button type="button" data-cart-qty="-1" data-variant-id="' + item.variant_id + '" aria-label="Decrease">−</button>' +
            '<span>' + g.qty + '</span>' +
            '<button type="button" data-cart-qty="1" data-variant-id="' + item.variant_id + '" aria-label="Increase">+</button>' +
            '</div>';
        html +=
          '<li class="cart-drawer__item" data-line="' + (i + 1) + '">' +
          imgHtml +
          '<div class="cart-drawer__info">' +
          '<p class="cart-drawer__title"><a href="' + escHtml(item.url) + '">' + titleLine + '</a></p>' +
          '<p class="cart-drawer__price">' + formatMoney(g.total) + '</p>' +
          controls +
          '</div></li>';
      });
      list.innerHTML = html;
    });
  }

  window.__mnRefreshDrawer = refreshDrawer; // v22: lets the bonus-kit script refresh the drawer
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshDrawer);
  else refreshDrawer();

  // Quantity +/- in drawer — v25: by variant across split lines, then re-render from /cart.js
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove-bonus]');
    var btn = e.target.closest('[data-cart-qty]');
    if (!rm && !btn) return;
    var vid = rm ? MN_BONUS_VARIANT : parseInt(btn.getAttribute('data-variant-id'), 10);
    var delta = rm ? 0 : parseInt(btn.getAttribute('data-cart-qty'), 10);
    if (btn) btn.disabled = true;
    fetchCart().then(function (cart) {
      var lines = cart.items.filter(function (it) { return it.variant_id === vid; });
      if (!lines.length) return null;
      if (rm) {
        // one change per bonus line, so the bonus script records that the shopper declined it
        return lines.reduce(function (p, it) { return p.then(function () { return cartChange(it.key, 0); }); }, Promise.resolve());
      }
      var target = delta > 0 ? lines[0] : lines[lines.length - 1];
      return cartChange(target.key, Math.max(0, target.quantity + delta));
    }).then(function () {
      refreshDrawer();
    }).catch(function () { window.location.reload(); });
  });

  // ===== Add-to-cart interception =====
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('form[action*="/cart/add"]') && !form.matches('.product-form') && !form.matches('.tier__form') && !form.matches('.tn-pdp__form')) return;
    if (!window.fetch) return;

    event.preventDefault();
    var data = new FormData(form);
    fetch(routes.cart_add_url, { method: 'POST', body: data, headers: { Accept: 'application/javascript' } })
      .then(function (r) { if (!r.ok) throw new Error('Add failed'); return r.json(); })
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        updateCartBadge(cart);
        if (drawer) { openDrawer(); refreshDrawer(); }
        var btn = form.querySelector('[type="submit"]');
        if (btn) {
          var orig = btn.textContent;
          btn.textContent = (window.theme && window.theme.strings && window.theme.strings.addedToCart) || 'Added';
          setTimeout(function () { btn.textContent = orig; }, 1600);
        }
      })
      .catch(function () { form.submit(); });
  });

  // ===== Variant select sync =====
  $$('.product-form').forEach(function (form) {
    var optionSelects = $$('.product-form__variants select', form);
    var variantSelect = $('.product-form__id', form);
    if (!optionSelects.length || !variantSelect) return;
    optionSelects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var chosen = optionSelects.map(function (s) { return s.value; }).join(' / ');
        Array.from(variantSelect.options).forEach(function (opt) {
          if (opt.textContent.trim() === chosen) variantSelect.value = opt.value;
        });
      });
    });
  });

  // ===== Product gallery thumbs =====
  $$('.product__thumb-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-product-thumb');
      var hero = $('.product__image');
      if (hero && src) hero.src = src;
    });
  });

  // ===== Sticky add-to-cart =====
  var sticky = $('[data-sticky-atc]');
  var primaryAtc = $('.product-form__submit');
  if (sticky && primaryAtc) {
    var stickyBtn = $('[data-sticky-atc-add]', sticky);
    stickyBtn && stickyBtn.addEventListener('click', function () {
      primaryAtc.click();
    });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { sticky.hidden = entry.isIntersecting; });
    }, { rootMargin: '0px 0px -50% 0px' });
    observer.observe(primaryAtc);
  }

  // ===== Bundle radio updates price =====
  $$('.product-form__bundle input[type="radio"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      var price = $('[data-product-price]');
      var bundle = radio.closest('.bundle-option');
      var bundlePrice = $('.bundle-option__price', bundle);
      if (price && bundlePrice) price.textContent = bundlePrice.textContent;
    });
  });

  // ===== Mobile nav =====
  var navToggle = $('[data-nav-toggle]');
  var nav = $('#MobileNav');
  // Inject × close button (mobile only — CSS hides it on desktop)
  if (nav && !nav.querySelector('.site-nav__close')) {
    var closeBtn = document.createElement('button');
    closeBtn.className = 'site-nav__close';
    closeBtn.setAttribute('aria-label', 'Close menu');
    closeBtn.innerHTML = '&times;';
    nav.insertBefore(closeBtn, nav.firstChild);
  }
  function closeMobileNav() {
    if (!nav) return;
    nav.classList.remove('is-open');
    navToggle && navToggle.setAttribute('aria-expanded', 'false');
  }
  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    var closeBtn2 = nav.querySelector('.site-nav__close');
    if (closeBtn2) closeBtn2.addEventListener('click', closeMobileNav);
  }

  // ===== Email popup =====
  var popup = $('[data-email-popup]');
  function openPopup() { if (!popup) return; popup.hidden = false; popup.classList.add('is-open'); }
  function closePopup() {
    if (!popup) return;
    popup.classList.remove('is-open');
    setTimeout(function () { popup.hidden = true; }, 250);
    try { localStorage.setItem('tn_popup_dismissed', '1'); } catch (e) {}
  }
  document.addEventListener('click', function (e) { if (e.target.closest('[data-email-popup-close]')) closePopup(); });
  (function maybeShowPopup() {
    if (!popup) return;
    try { if (localStorage.getItem('tn_popup_dismissed')) return; } catch (e) {}
    var delay = (window.theme && window.theme.popupDelay) || 8;
    setTimeout(openPopup, delay * 1000);
  })();
})();

// ============================================================
// Travel Nosh PDP — product page state machine (v2.6)
// Course and nutrition data read from metafield JSON script tags.
// ============================================================
(function () {
  'use strict';

  var pdp = document.querySelector('[data-pdp]');
  if (!pdp) return;

  // ── Load data islands ───────────────────────────────────────
  var variantsEl  = pdp.querySelector('[data-pdp-variants]');
  var configEl    = pdp.querySelector('[data-pdp-config]');
  var coursesEl   = pdp.querySelector('[data-pdp-courses]');
  var nutritionEl = pdp.querySelector('[data-pdp-nutrition]');

  if (!variantsEl) return;

  var VARIANTS, CONFIG = {}, COURSES_BY_ED = {}, NUTRITION = {};

  try { VARIANTS = JSON.parse(variantsEl.textContent); }
  catch (e) { console.error('TN PDP: variants parse failed', e); return; }
  try { if (configEl)    CONFIG        = JSON.parse(configEl.textContent);    } catch (e) {}
  try { if (coursesEl)   COURSES_BY_ED = JSON.parse(coursesEl.textContent);   } catch (e) {}
  try { if (nutritionEl) NUTRITION     = JSON.parse(nutritionEl.textContent);  } catch (e) {}

  var SUB_PCT         = typeof CONFIG.subscribe_pct === 'number' ? CONFIG.subscribe_pct : 0.15;
  var SELLING_PLAN_ID = CONFIG.selling_plan_id || '';

  var EDITION_LABELS = { iq: 'IQ Bar', quest: 'Quest Bar', chomps: 'Chomps' };

  // ── State ───────────────────────────────────────────────────
  var state = { edition: null, pack: null, subscribe: false };

  function $$(sel, ctx) { return Array.from((ctx || pdp).querySelectorAll(sel)); }
  function $(sel, ctx)  { return (ctx || pdp).querySelector(sel); }

  // ── Helpers ─────────────────────────────────────────────────
  function money(cents) {
    if (cents == null) return '';
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function packQty(label) {
    var m = String(label || '').match(/(\d+)/);
    return m ? parseInt(m[1], 10) : 1;
  }
  function variantPackVal(v) {
    var opts = [v.option1, v.option2, v.option3];
    return opts.find(function (o) { return o && /\d+.?pack/i.test(o); }) || opts[0];
  }

  // ── URL params ──────────────────────────────────────────────
  function readUrlParams() {
    try {
      var p = new URLSearchParams(window.location.search);
      if (p.get('edition')) state.edition = p.get('edition');
      if (p.get('pack'))    state.pack    = p.get('pack');
    } catch (e) {}
  }

  // ── Init from rendered form ─────────────────────────────────
  function initFromForm() {
    $$('.tn-pdp__edition.is-active').forEach(function (el) {
      if (!state.edition) state.edition = el.getAttribute('data-pdp-edition-handle');
    });
    $$('.tn-pdp__pack.is-active').forEach(function (el) {
      if (!state.pack) state.pack = el.getAttribute('data-pdp-pack');
    });
    if (!state.edition) {
      var firstEd = $('.tn-pdp__edition');
      if (firstEd) state.edition = firstEd.getAttribute('data-pdp-edition-handle');
    }
    if (!state.pack) {
      var firstPack = $('.tn-pdp__pack');
      if (firstPack) state.pack = firstPack.getAttribute('data-pdp-pack');
    }
  }

  // ── Variant lookup ──────────────────────────────────────────
  function findVariant() {
    if (!VARIANTS || !VARIANTS.length) return null;
    return VARIANTS.find(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      var packMatch = state.pack ? opts.indexOf(state.pack) >= 0 : true;
      var edMatch = true;
      if (state.edition) {
        edMatch = opts.some(function (o) {
          return o && o.toLowerCase().indexOf(state.edition) >= 0;
        });
      }
      return packMatch && edMatch;
    }) || VARIANTS[0];
  }

  // ── Render functions ────────────────────────────────────────
  function updateImageState() {
    var ed = state.edition || '';
    $$('[data-pdp-hero],[data-pdp-pouch]').forEach(function (el) {
      el.setAttribute('data-edition', ed);
    });
    var pouchEd = $('[data-pdp-pouch-ed]');
    if (pouchEd) pouchEd.textContent = (EDITION_LABELS[ed] || '—') + ' Edition';
    pdp.setAttribute('data-edition', ed);
  }

  function updateEditionChips() {
    $$('.tn-pdp__edition').forEach(function (el) {
      var h = el.getAttribute('data-pdp-edition-handle');
      el.classList.toggle('is-active', h === state.edition);
      var inp = el.querySelector('input[type="radio"]');
      if (inp) inp.checked = (h === state.edition);
    });
  }

  function updatePackButtons() {
    $$('.tn-pdp__pack').forEach(function (el) {
      var v = el.getAttribute('data-pdp-pack');
      el.classList.toggle('is-active', v === state.pack);
      var inp = el.querySelector('input[type="radio"]');
      if (inp) inp.checked = (v === state.pack);

      var match = VARIANTS.find(function (vrt) {
        var opts = [vrt.option1, vrt.option2, vrt.option3];
        var packOk = opts.indexOf(v) >= 0;
        if (!state.edition) return packOk;
        return packOk && opts.some(function (o) {
          return o && o.toLowerCase().indexOf(state.edition) >= 0;
        });
      });
      if (match) {
        var price   = state.subscribe ? Math.round(match.price * (1 - SUB_PCT)) : match.price;
        var qty     = packQty(v);
        var priceEl = el.querySelector('[data-pdp-pack-price]');
        var ppuEl   = el.querySelector('[data-pdp-pack-ppu]');
        if (priceEl) priceEl.textContent = money(price);
        if (ppuEl)   ppuEl.textContent   = money(price / qty) + ' / kit';
      }
    });
  }

  function updatePriceRow(variant) {
    if (!variant) return;
    var shown = state.subscribe ? Math.round(variant.price * (1 - SUB_PCT)) : variant.price;
    var qty   = packQty(state.pack);
    var main  = $('[data-pdp-price-main]');
    var ppu   = $('[data-pdp-price-ppu]');
    var save  = $('[data-pdp-price-save]');
    if (main) main.textContent = money(shown);
    if (ppu)  ppu.textContent  = qty > 1 ? money(shown / qty) + ' / kit' : '';

    if (save) {
      var relevant = VARIANTS.filter(function (v) {
        if (!state.edition) return true;
        return [v.option1, v.option2, v.option3].some(function (o) {
          return o && o.toLowerCase().indexOf(state.edition) >= 0;
        });
      });
      if (relevant.length > 1) {
        var smallest = relevant.reduce(function (a, b) {
          return packQty(variantPackVal(b)) < packQty(variantPackVal(a)) ? b : a;
        });
        var basePpu  = smallest.price / packQty(variantPackVal(smallest));
        var savedPct = Math.round((1 - (shown / qty) / basePpu) * 100);
        save.hidden      = savedPct <= 0;
        save.textContent = savedPct > 0 ? 'Save ' + savedPct + '%' : '';
      } else {
        save.hidden = true;
      }
    }
  }

  function updateSubscribe(variant) {
    var sub = $('[data-pdp-sub]');
    if (!sub) return;
    sub.classList.toggle('is-on', state.subscribe);
    var inp = $('[data-pdp-sub-input]');
    if (inp) {
      inp.checked = state.subscribe;
      inp.value   = state.subscribe && SELLING_PLAN_ID ? SELLING_PLAN_ID : '';
    }
    var subPrice = $('[data-pdp-sub-price]');
    if (subPrice && variant) {
      subPrice.textContent = money(Math.round(variant.price * (1 - SUB_PCT)));
    }
    var cancel = $('[data-pdp-cancel]');
    if (cancel) cancel.hidden = !state.subscribe;
  }

  function updateCta(variant) {
    var ctaText  = $('[data-pdp-cta-text]');
    var vidInput = $('[data-pdp-variant-id]');
    if (vidInput && variant) vidInput.value = variant.id;
    if (!ctaText || !variant) return;
    var shown = state.subscribe ? Math.round(variant.price * (1 - SUB_PCT)) : variant.price;
    var parts = [];
    if (state.edition && EDITION_LABELS[state.edition]) parts.push(EDITION_LABELS[state.edition]);
    if (state.pack) parts.push(state.pack);
    parts.push(money(shown));
    ctaText.textContent = 'Add to cart — ' + parts.join(' · ');
  }

  // ── Course strip ────────────────────────────────────────────
  var ICON_SVG = {
    sun:     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="4"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M5 19l2-2M17 7l2-2"/></svg>',
    barbell: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="9" width="18" height="6" rx="1"/><line x1="7" y1="6" x2="7" y2="18"/><line x1="17" y1="6" x2="17" y2="18"/></svg>',
    flame:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2c0 6-6 7-6 13a6 6 0 0 0 12 0c0-6-6-7-6-13z"/></svg>',
    droplet: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3l6 9a6 6 0 1 1-12 0z"/></svg>',
    star:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15 9 22 9.5 17 14.5 18.5 22 12 18 5.5 22 7 14.5 2 9.5 9 9"/></svg>',
    leaf:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 21c8-1 14-7 15-15-8 1-14 7-15 15z"/></svg>'
  };
  function iconSvg(name) { return ICON_SVG[name] || ICON_SVG.barbell; }

  function updateCourseStrip() {
    var strip  = $('[data-pdp-course-strip]');
    var detail = $('[data-pdp-course-detail]');
    if (!strip) return;

    var ed      = state.edition || 'iq';
    var courses = COURSES_BY_ED[ed] || COURSES_BY_ED['iq'] || [];
    if (!courses.length) return;

    var stripHtml = '', detailHtml = '';
    var maxSlots  = Math.max(courses.length, 3);

    for (var i = 0; i < maxSlots; i++) {
      if (i > 0) stripHtml += '<div class="tn-pdp__cs-arrow">›</div>';
      var c = courses[i];
      if (c) {
        stripHtml +=
          '<div class="tn-pdp__cs-item' + (c.highlight ? ' is-hi' : '') + '">' +
          '<div class="tn-pdp__cs-dot tn-pdp__cs-dot--' + (c.icon || 'barbell') + '">' +
          iconSvg(c.icon || 'barbell') + '</div>' +
          '<div class="tn-pdp__cs-name">' + (c.name || '') + '</div></div>';
      } else {
        stripHtml +=
          '<div class="tn-pdp__cs-item">' +
          '<div class="tn-pdp__cs-empty"></div>' +
          '<div class="tn-pdp__cs-name">—</div></div>';
      }
    }
    strip.innerHTML = stripHtml;

    if (detail) {
      courses.forEach(function (c) {
        detailHtml +=
          '<div class="tn-pdp__cd-row">' +
          '<div class="tn-pdp__cd-dot tn-pdp__cs-dot--' + (c.icon || 'barbell') + '">' +
          iconSvg(c.icon || 'barbell') + '</div>' +
          '<div class="tn-pdp__cd-name">' + (c.name || '') + '</div>' +
          '<div class="tn-pdp__cd-item">' + (c.item || '') + '</div>' +
          '<div class="tn-pdp__cd-note">' + (c.note || '') + '</div></div>';
      });
      detail.innerHTML = detailHtml;
    }
  }

  // ── Nutrition ───────────────────────────────────────────────
  function updateNutrition() {
    var ed = state.edition || 'iq';
    var n  = NUTRITION[ed] || NUTRITION['iq'];
    if (!n) return;
    var cal  = $('[data-pdp-nutr-cal]');
    var prot = $('[data-pdp-nutr-prot]');
    var carb = $('[data-pdp-nutr-carb]');
    if (cal)  cal.textContent  = n.cal     || '—';
    if (prot) prot.textContent = n.protein  || '—';
    if (carb) carb.textContent = n.carbs    || '—';
  }

  // ── Master render ───────────────────────────────────────────
  function render() {
    var variant = findVariant();
    updateImageState();
    updateEditionChips();
    updatePackButtons();
    updatePriceRow(variant);
    updateSubscribe(variant);
    updateCta(variant);
    updateCourseStrip();
    updateNutrition();
    try {
      var url = new URL(window.location);
      if (state.edition) url.searchParams.set('edition', state.edition);
      else url.searchParams.delete('edition');
      if (state.pack) url.searchParams.set('pack', state.pack);
      else url.searchParams.delete('pack');
      window.history.replaceState({}, '', url);
    } catch (e) {}
  }

  // ── Event wiring ────────────────────────────────────────────
  $$('.tn-pdp__edition').forEach(function (el) {
    el.addEventListener('click', function () {
      state.edition = el.getAttribute('data-pdp-edition-handle');
      render();
    });
  });

  $$('.tn-pdp__pack').forEach(function (el) {
    el.addEventListener('click', function () {
      state.pack = el.getAttribute('data-pdp-pack');
      render();
    });
  });

  var subEl = $('[data-pdp-sub]');
  if (subEl) {
    subEl.addEventListener('click', function (e) {
      if (e.target.tagName === 'INPUT') return;
      state.subscribe = !state.subscribe;
      render();
    });
  }

  var detailToggle = $('[data-pdp-detail-toggle]');
  var courseDetail = $('[data-pdp-course-detail]');
  if (detailToggle && courseDetail) {
    detailToggle.addEventListener('click', function () {
      var hidden = courseDetail.hasAttribute('hidden');
      if (hidden) { courseDetail.removeAttribute('hidden'); detailToggle.textContent = '− Hide courses'; }
      else        { courseDetail.setAttribute('hidden', ''); detailToggle.textContent = '+ See all courses'; }
    });
  }

  $$('[data-pdp-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      $$('.tn-pdp__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var src = btn.getAttribute('data-pdp-thumb');
      var heroImg = $('.tn-pdp__hero-img');
      if (heroImg && src) heroImg.src = src;
    });
  });

  var stickyBar  = $('[data-pdp-sticky]');
  var primaryCta = $('[data-pdp-cta]');
  if (stickyBar && primaryCta) {
    var stickyBtn = $('[data-pdp-sticky-add]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () { primaryCta.click(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { stickyBar.hidden = entry.isIntersecting; });
      }, { rootMargin: '0px 0px -50% 0px' }).observe(primaryCta);
    }
  }

  // ── Bootstrap ───────────────────────────────────────────────
  readUrlParams();
  initFromForm();
  if (!state.edition) {
    var firstEdEl = $('.tn-pdp__edition');
    if (firstEdEl) state.edition = firstEdEl.getAttribute('data-pdp-edition-handle');
  }
  if (!state.pack) {
    var firstPackEl = $('.tn-pdp__pack');
    if (firstPackEl) state.pack = firstPackEl.getAttribute('data-pdp-pack');
  }
  render();
})();


  // ── Description read-more / read-less ───────────────────────
  (function () {
    var descBody   = document.querySelector('[data-pdp-desc-body]');
    var descToggle = document.querySelector('[data-pdp-desc-toggle]');
    if (!descBody || !descToggle) return;
    var lh = parseFloat(window.getComputedStyle(descBody).lineHeight) || 24;
    if (descBody.scrollHeight > lh * 4) {
      descBody.classList.add('is-collapsed');
      descToggle.removeAttribute('hidden');
      descToggle.addEventListener('click', function () {
        var collapsed = descBody.classList.toggle('is-collapsed');
        descToggle.textContent = collapsed ? 'Read more' : 'Read less';
      });
    }
  })();

// ============================================================
// Travel Nosh Kit Comparison — cross-product selector (v1.0)
// Drives [data-cmp] section. Reads one [data-cmp-data] island
// containing all 3 products. Tab clicks switch active product;
// edition/pack/subscribe work identically to PDP state machine.
// ============================================================
(function () {
  'use strict';

  var cmp = document.querySelector('[data-cmp]');
  if (!cmp) return;

  var dataEl = cmp.querySelector('[data-cmp-data]');
  if (!dataEl) return;

  var ALL;
  try { ALL = JSON.parse(dataEl.textContent); }
  catch (e) { console.error('TN Compare: data parse failed', e); return; }

  // Index products by handle for fast lookup
  var PRODUCTS = {};
  (ALL.products || []).forEach(function (p) { PRODUCTS[p.handle] = p; });

  var HANDLES     = (ALL.products || []).map(function (p) { return p.handle; });
  var SUB_PCT     = typeof ALL.subscribe_pct === 'number' ? ALL.subscribe_pct : 0.15;
  var SELLING_ID  = ALL.selling_plan_id || '';
  var EDITION_LABELS = { iq: 'IQ Bar', quest: 'Quest Bar', chomps: 'Chomps' };

  var state = { handle: HANDLES[0] || null, edition: null, pack: null, subscribe: false };

  function $$(sel, ctx) { return Array.from((ctx || cmp).querySelectorAll(sel)); }
  function $(sel, ctx)  { return (ctx || cmp).querySelector(sel); }

  // ── Helpers ─────────────────────────────────────────────────
  function money(cents) {
    if (cents == null) return '';
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function packQty(label) {
    var m = String(label || '').match(/(\d+)/);
    return m ? parseInt(m[1], 10) : 1;
  }
  function variantPackVal(v) {
    var opts = [v.option1, v.option2, v.option3];
    return opts.find(function (o) { return o && /\d+.?pack/i.test(o); }) || opts[0];
  }

  var ICON_SVG = {
    sun:     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="4"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M5 19l2-2M17 7l2-2"/></svg>',
    barbell: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="9" width="18" height="6" rx="1"/><line x1="7" y1="6" x2="7" y2="18"/><line x1="17" y1="6" x2="17" y2="18"/></svg>',
    flame:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2c0 6-6 7-6 13a6 6 0 0 0 12 0c0-6-6-7-6-13z"/></svg>',
    droplet: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3l6 9a6 6 0 1 1-12 0z"/></svg>',
    star:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15 9 22 9.5 17 14.5 18.5 22 12 18 5.5 22 7 14.5 2 9.5 9 9"/></svg>',
    leaf:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 21c8-1 14-7 15-15-8 1-14 7-15 15z"/></svg>'
  };
  function iconSvg(name) { return ICON_SVG[name] || ICON_SVG.barbell; }

  // ── Variant lookup within active product ────────────────────
  function findVariant(prod) {
    if (!prod || !prod.variants || !prod.variants.length) return null;
    return prod.variants.find(function (v) {
      var opts     = [v.option1, v.option2, v.option3];
      var packOk   = state.pack ? opts.indexOf(state.pack) >= 0 : true;
      var edOk     = true;
      if (state.edition) {
        edOk = opts.some(function (o) {
          return o && o.toLowerCase().indexOf(state.edition) >= 0;
        });
      }
      return packOk && edOk;
    }) || prod.variants[0];
  }

  // ── Render: tabs ────────────────────────────────────────────
  function updateTabs() {
    $$('[data-cmp-tab]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-cmp-tab') === state.handle);
    });
  }

  // ── Render: hero image / pouch ──────────────────────────────
  function updateHero(prod) {
    var hero = $('[data-cmp-hero]');
    if (!hero) return;
    hero.setAttribute('data-edition', state.edition || '');

    if (prod && prod.image) {
      // Show product image
      var existing = hero.querySelector('.tn-pdp__hero-img');
      if (existing) {
        existing.src = prod.image;
      } else {
        hero.innerHTML = '<img class="tn-pdp__hero-img" src="' + prod.image + '" alt="' + (prod.title || '') + '" loading="eager">';
      }
    } else {
      // Show branded pouch fallback
      var pouch = $('[data-cmp-pouch]');
      if (pouch) {
        pouch.setAttribute('data-edition', state.edition || '');
        var kitEl = hero.querySelector('[data-cmp-pouch-kit]');
        if (kitEl && prod) kitEl.textContent = prod.title || '';
        var edEl = hero.querySelector('[data-cmp-pouch-ed]');
        if (edEl) edEl.textContent = (EDITION_LABELS[state.edition] || '—') + ' Edition';
      }
    }
  }

  // ── Render: product title + subtitle ───────────────────────
  function updateProductInfo(prod) {
    var titleEl = $('[data-cmp-product-title]');
    var subEl   = $('[data-cmp-product-sub]');
    var bcEl    = $('[data-cmp-title]');
    if (!prod) return;
    if (titleEl) titleEl.textContent = prod.title || '';
    if (bcEl)    bcEl.textContent    = prod.title || '';
    if (subEl) {
      var full  = prod.subtitle || '';
      var LIMIT = 120;
      if (!full || full.length <= LIMIT) {
        subEl.textContent = full;
      } else {
        var short = full.slice(0, LIMIT).trimEnd();
        subEl.innerHTML =
          '<span class="tn-cmp__sub-short">' + short + '\u2026 ' +
          '<button type="button" class="tn-cmp__read-more">Read more</button></span>' +
          '<span class="tn-cmp__sub-full" hidden>' + full + ' ' +
          '<button type="button" class="tn-cmp__read-less">Read less</button></span>';
        var rm = subEl.querySelector('.tn-cmp__read-more');
        var rl = subEl.querySelector('.tn-cmp__read-less');
        var se = subEl.querySelector('.tn-cmp__sub-short');
        var fe = subEl.querySelector('.tn-cmp__sub-full');
        rm.addEventListener('click', function () { se.hidden = true;  fe.removeAttribute('hidden'); });
        rl.addEventListener('click', function () { se.hidden = false; fe.setAttribute('hidden', ''); });
      }
    }
  }

  // ── Render: edition chips ───────────────────────────────────
  function updateEditionChips(prod) {
    var container  = $('[data-cmp-editions]');
    var labelEl    = $('[data-cmp-edition-label]');
    if (!container) return;

    // Find edition option
    var edOption = null;
    if (prod && prod.options) {
      edOption = prod.options.find(function (o) {
        return o.name && o.name.toLowerCase() === 'edition';
      });
    }

    if (!edOption || !edOption.values || !edOption.values.length) {
      container.innerHTML = '';
      if (labelEl) labelEl.style.display = 'none';
      return;
    }

    if (labelEl) labelEl.style.display = '';
    var html = '';
    edOption.values.forEach(function (value) {
      var handle = value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').replace(/-bar$/, '');
      var active = (handle === state.edition);
      html += '<label class="tn-pdp__edition tn-pdp__edition--' + handle +
              (active ? ' is-active' : '') + '" data-cmp-edition="' + handle + '">' +
              '<input type="radio" hidden ' + (active ? 'checked' : '') + '>' +
              '<span class="tn-pdp__edition-name">' + value + '</span>' +
              '</label>';
    });
    container.innerHTML = html;

    // Wire clicks
    $$('[data-cmp-edition]', container).forEach(function (el) {
      el.addEventListener('click', function () {
        state.edition = el.getAttribute('data-cmp-edition');
        render();
      });
    });
  }

  // ── Render: pack buttons ────────────────────────────────────
  function updatePackButtons(prod, variant) {
    var container = $('[data-cmp-packs]');
    var labelEl   = $('[data-cmp-pack-label]');
    if (!container) return;

    // Find pack option
    var packOption = null;
    if (prod && prod.options) {
      packOption = prod.options.find(function (o) {
        return o.name && o.name.toLowerCase().indexOf('pack') >= 0;
      });
    }

    if (!packOption || !packOption.values || !packOption.values.length) {
      container.innerHTML = '';
      if (labelEl) labelEl.style.display = 'none';
      return;
    }

    if (labelEl) labelEl.style.display = '';
    var vals    = packOption.values;
    var isMid3  = vals.length === 3; // badge middle option if exactly 3
    var html    = '';

    vals.forEach(function (value, idx) {
      var active  = (value === state.pack);
      var popular = isMid3 && idx === 1;

      // Find variant for this pack + current edition
      var match = (prod.variants || []).find(function (v) {
        var opts   = [v.option1, v.option2, v.option3];
        var packOk = opts.indexOf(value) >= 0;
        if (!state.edition) return packOk;
        var edOk   = opts.some(function (o) {
          return o && o.toLowerCase().indexOf(state.edition) >= 0;
        });
        return packOk && edOk;
      });

      var price    = match ? (state.subscribe ? Math.round(match.price * (1 - SUB_PCT)) : match.price) : null;
      var qty      = packQty(value);
      var priceStr = price != null ? money(price) : '';
      var ppuStr   = price != null ? money(price / qty) + ' / kit' : '';

      html += '<label class="tn-pdp__pack' + (active ? ' is-active' : '') +
              '" data-cmp-pack="' + value + '">' +
              '' + // v24: "Most popular" pack badge removed (Legal Guardrails section 5)
              '<input type="radio" hidden ' + (active ? 'checked' : '') + '>' +
              '<span class="tn-pdp__pack-qty">'   + value   + '</span>' +
              '<span class="tn-pdp__pack-price">' + priceStr + '</span>' +
              '<span class="tn-pdp__pack-ppu">'   + ppuStr   + '</span>' +
              '</label>';
    });
    container.innerHTML = html;

    // Wire clicks
    $$('[data-cmp-pack]', container).forEach(function (el) {
      el.addEventListener('click', function () {
        state.pack = el.getAttribute('data-cmp-pack');
        render();
      });
    });
  }

  // ── Render: price row ───────────────────────────────────────
  function updatePriceRow(prod, variant) {
    if (!variant) return;
    var shown = state.subscribe ? Math.round(variant.price * (1 - SUB_PCT)) : variant.price;
    var qty   = packQty(state.pack);
    var main  = $('[data-cmp-price-main]');
    var ppu   = $('[data-cmp-price-ppu]');
    var save  = $('[data-cmp-price-save]');
    if (main) main.textContent = money(shown);
    if (ppu)  ppu.textContent  = qty > 1 ? money(shown / qty) + ' / kit' : '';
    if (save) {
      var relevant = (prod && prod.variants ? prod.variants : []).filter(function (v) {
        if (!state.edition) return true;
        return [v.option1, v.option2, v.option3].some(function (o) {
          return o && o.toLowerCase().indexOf(state.edition) >= 0;
        });
      });
      if (relevant.length > 1) {
        var smallest = relevant.reduce(function (a, b) {
          return packQty(variantPackVal(b)) < packQty(variantPackVal(a)) ? b : a;
        });
        var basePpu  = smallest.price / packQty(variantPackVal(smallest));
        var savedPct = Math.round((1 - (shown / qty) / basePpu) * 100);
        save.hidden      = savedPct <= 0;
        save.textContent = savedPct > 0 ? 'Save ' + savedPct + '%' : '';
      } else {
        save.hidden = true;
      }
    }
  }

  // ── Render: subscribe toggle ────────────────────────────────
  function updateSubscribe(variant) {
    var sub = $('[data-cmp-sub]');
    if (!sub) return;
    sub.classList.toggle('is-on', state.subscribe);
    var inp = $('[data-cmp-sub-input]');
    if (inp) {
      inp.checked = state.subscribe;
      inp.value   = state.subscribe && SELLING_ID ? SELLING_ID : '';
    }
    var subPrice = $('[data-cmp-sub-price]');
    if (subPrice && variant) {
      subPrice.textContent = money(Math.round(variant.price * (1 - SUB_PCT)));
    }
    var cancel = $('[data-cmp-cancel]');
    if (cancel) cancel.hidden = !state.subscribe;
  }

  // ── Render: CTA button ──────────────────────────────────────
  function updateCta(prod, variant) {
    var ctaText  = $('[data-cmp-cta-text]');
    var vidInput = $('[data-cmp-variant-id]');
    if (vidInput && variant) vidInput.value = variant.id;
    if (!ctaText) return;
    if (!variant) { ctaText.textContent = 'Select a kit to continue'; return; }
    var shown  = state.subscribe ? Math.round(variant.price * (1 - SUB_PCT)) : variant.price;
    var parts  = [];
    if (state.edition && EDITION_LABELS[state.edition]) parts.push(EDITION_LABELS[state.edition]);
    if (state.pack) parts.push(state.pack);
    parts.push(money(shown));
    ctaText.textContent = 'Add to cart — ' + parts.join(' · ');
  }

  // ── Render: course strip ────────────────────────────────────
  function updateCourseStrip(prod) {
    var header = $('[data-cmp-inside-header]');
    var strip  = $('[data-cmp-course-strip]');
    var detail = $('[data-cmp-course-detail]');
    if (!strip) return;

    var ed      = state.edition || 'iq';
    var courses = (prod && prod.courses) ? (prod.courses[ed] || prod.courses['iq'] || []) : [];

    if (!courses.length) {
      if (header) header.hidden = true;
      strip.innerHTML = '';
      if (detail) detail.innerHTML = '';
      return;
    }

    if (header) header.hidden = false;
    var maxSlots  = Math.max(courses.length, 3);
    var stripHtml = '', detailHtml = '';

    for (var i = 0; i < maxSlots; i++) {
      if (i > 0) stripHtml += '<div class="tn-pdp__cs-arrow">›</div>';
      var c = courses[i];
      if (c) {
        stripHtml +=
          '<div class="tn-pdp__cs-item' + (c.highlight ? ' is-hi' : '') + '">' +
          '<div class="tn-pdp__cs-dot tn-pdp__cs-dot--' + (c.icon || 'barbell') + '">' +
          iconSvg(c.icon || 'barbell') + '</div>' +
          '<div class="tn-pdp__cs-name">' + (c.name || '') + '</div></div>';
      } else {
        stripHtml +=
          '<div class="tn-pdp__cs-item"><div class="tn-pdp__cs-empty"></div>' +
          '<div class="tn-pdp__cs-name">—</div></div>';
      }
    }
    strip.innerHTML = stripHtml;

    if (detail) {
      courses.forEach(function (c) {
        detailHtml +=
          '<div class="tn-pdp__cd-row">' +
          '<div class="tn-pdp__cd-dot tn-pdp__cs-dot--' + (c.icon || 'barbell') + '">' +
          iconSvg(c.icon || 'barbell') + '</div>' +
          '<div class="tn-pdp__cd-name">' + (c.name || '') + '</div>' +
          '<div class="tn-pdp__cd-item">' + (c.item || '') + '</div>' +
          '<div class="tn-pdp__cd-note">' + (c.note || '') + '</div></div>';
      });
      detail.innerHTML = detailHtml;
    }
  }

  // ── Render: nutrition ───────────────────────────────────────
  function updateNutrition(prod) {
    var grid = $('[data-cmp-nutr]');
    var ed   = state.edition || 'iq';
    var n    = (prod && prod.nutrition) ? (prod.nutrition[ed] || prod.nutrition['iq']) : null;
    if (grid) grid.hidden = !n;
    if (!n) return;
    var cal  = $('[data-cmp-nutr-cal]');
    var prot = $('[data-cmp-nutr-prot]');
    var carb = $('[data-cmp-nutr-carb]');
    if (cal)  cal.textContent  = n.cal     || '—';
    if (prot) prot.textContent = n.protein  || '—';
    if (carb) carb.textContent = n.carbs    || '—';
  }

  // ── Master render ───────────────────────────────────────────
  function render() {
    var prod    = PRODUCTS[state.handle] || null;
    var variant = findVariant(prod);
    updateTabs();
    updateHero(prod);
    updateProductInfo(prod);
    updateEditionChips(prod);
    updatePackButtons(prod, variant);
    updatePriceRow(prod, variant);
    updateSubscribe(variant);
    updateCta(prod, variant);
    updateCourseStrip(prod);
    updateNutrition(prod);
    try {
      var url = new URL(window.location);
      if (state.handle)  url.searchParams.set('kit',     state.handle);
      if (state.edition) url.searchParams.set('edition', state.edition);
      if (state.pack)    url.searchParams.set('pack',    state.pack);
      window.history.replaceState({}, '', url);
    } catch (e) {}
  }

  // ── Event wiring ────────────────────────────────────────────
  // Tab clicks
  $$('[data-cmp-tab]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var newHandle = btn.getAttribute('data-cmp-tab');
      if (newHandle === state.handle) return;
      state.handle = newHandle;
      // Reset edition and pack to first available on product switch
      var prod = PRODUCTS[newHandle];
      state.edition = null;
      state.pack    = null;
      if (prod && prod.options) {
        var edOpt = prod.options.find(function (o) {
          return o.name && o.name.toLowerCase() === 'edition';
        });
        if (edOpt && edOpt.values && edOpt.values.length) {
          state.edition = edOpt.values[0].toLowerCase()
            .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').replace(/-bar$/, '').split('-')[0];
        }
        var pkOpt = prod.options.find(function (o) {
          return o.name && o.name.toLowerCase().indexOf('pack') >= 0;
        });
        if (pkOpt && pkOpt.values && pkOpt.values.length) {
          state.pack = pkOpt.values[Math.min(1, pkOpt.values.length - 1)]; // default to middle
        }
      }
      render();
    });
  });

  // Subscribe toggle
  var subEl = $('[data-cmp-sub]');
  if (subEl) {
    subEl.addEventListener('click', function (e) {
      if (e.target.tagName === 'INPUT') return;
      state.subscribe = !state.subscribe;
      render();
    });
  }

  // Detail expand toggle
  var detailToggle = $('[data-cmp-detail-toggle]');
  var courseDetail = $('[data-cmp-course-detail]');
  if (detailToggle && courseDetail) {
    detailToggle.addEventListener('click', function () {
      var hidden = courseDetail.hasAttribute('hidden');
      if (hidden) { courseDetail.removeAttribute('hidden'); detailToggle.textContent = '− Hide courses'; }
      else        { courseDetail.setAttribute('hidden', ''); detailToggle.textContent = '+ See all courses'; }
    });
  }

  // ── URL params on load ──────────────────────────────────────
  try {
    var urlP = new URLSearchParams(window.location.search);
    if (urlP.get('kit') && PRODUCTS[urlP.get('kit')])  state.handle  = urlP.get('kit');
    if (urlP.get('edition'))                            state.edition = urlP.get('edition');
    if (urlP.get('pack'))                               state.pack    = urlP.get('pack');
  } catch (e) {}

  // ── Bootstrap ───────────────────────────────────────────────
  if (!state.handle && HANDLES.length) state.handle = HANDLES[0];

  var firstProd = PRODUCTS[state.handle];
  if (firstProd && firstProd.options) {
    if (!state.edition) {
      var edOpt = firstProd.options.find(function (o) {
        return o.name && o.name.toLowerCase() === 'edition';
      });
      if (edOpt && edOpt.values && edOpt.values.length) {
        state.edition = edOpt.values[0].toLowerCase()
          .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').replace(/-bar$/, '').split('-')[0];
      }
    }
    if (!state.pack) {
      var pkOpt = firstProd.options.find(function (o) {
        return o.name && o.name.toLowerCase().indexOf('pack') >= 0;
      });
      if (pkOpt && pkOpt.values && pkOpt.values.length) {
        state.pack = pkOpt.values[Math.min(1, pkOpt.values.length - 1)];
      }
    }
  }

  render();
})();






/* footer-accordion-v5 */
(function () {
  function initFooterAccordion() {
    document.querySelectorAll('.site-footer__col').forEach(function (col) {
      if (!col.querySelector('ul')) return; // skip newsletter section
      col.classList.add('has-accordion');
      var h4 = col.querySelector('h4');
      if (!h4 || h4.dataset.acc) return;
      h4.dataset.acc = '1';
      h4.setAttribute('role', 'button');
      h4.setAttribute('tabindex', '0');
      h4.addEventListener('click', function () { col.classList.toggle('is-open'); });
      h4.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); col.classList.toggle('is-open'); }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterAccordion);
  } else {
    initFooterAccordion();
  }
})();

// v22: WELCOMENOSH — free Bonus Nosh Kit auto-add/remove (Patch #22)
// Shopify discounts can't add the free item themselves. When the cart holds a
// Nosh Kit and the WELCOMENOSH code is active (set by midnosh.com/discount/WELCOMENOSH
// links), add one Bonus Nosh Kit; remove it when no kit remains; cap it at 1.
// A shopper who removes the bonus on purpose isn't re-added it this session.
(function () {
  'use strict';
  if (!window.fetch) return;
  var CODE = 'WELCOMENOSH';
  var BONUS_VARIANT = 67686526877805;
  var KIT_PRODUCTS = [8086793912429, 8086793945197, 8086793977965];
  var DECLINED_KEY = 'mn_bonus_declined';
  var origFetch = window.fetch.bind(window);
  var busy = false, again = false;

  function hasCode(cart) {
    var inCart = (cart.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === CODE; });
    return inCart || new RegExp('(?:^|;\s*)discount_code=' + CODE + '(?:;|$)', 'i').test(document.cookie);
  }
  function declined() { try { return sessionStorage.getItem(DECLINED_KEY) === '1'; } catch (e) { return false; } }
  function getCart() { return origFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(url, payload) {
    return origFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { if (!r.ok) throw new Error('bonus kit: ' + url); return r.json(); });
  }
  function afterChange() {
    if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    getCart().then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      if (typeof window.__mnRefreshDrawer === 'function') window.__mnRefreshDrawer();
    });
  }
  function reconcile() {
    if (busy) { again = true; return; }
    busy = true;
    getCart().then(function (cart) {
      // v25: count the bonus across every cart line (Shopify can split it) and keep the total at 1
      var kits = 0, bonusLines = [];
      cart.items.forEach(function (it) {
        if (it.variant_id === BONUS_VARIANT) bonusLines.push(it);
        else if (KIT_PRODUCTS.indexOf(it.product_id) !== -1) kits += it.quantity;
      });
      var bonusQty = bonusLines.reduce(function (n, it) { return n + it.quantity; }, 0);
      var qualifies = kits > 0 && hasCode(cart);
      if (!bonusQty && qualifies && !declined()) {
        return post('/cart/add.js', { items: [{ id: BONUS_VARIANT, quantity: 1, properties: { _gift: CODE } }] }).then(afterChange);
      }
      if (bonusQty && !qualifies) {
        var none = {};
        bonusLines.forEach(function (it) { none[it.key] = 0; });
        return post('/cart/update.js', { updates: none }).then(afterChange);
      }
      if (bonusQty > 1) {
        var one = {};
        bonusLines.forEach(function (it, i) { one[it.key] = i === 0 ? 1 : 0; });
        return post('/cart/update.js', { updates: one }).then(afterChange);
      }
    }).catch(function () {}).then(function () {
      busy = false;
      if (again) { again = false; reconcile(); }
    });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCart = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
    if (isCart && /\/cart\/change/.test(url) && init && typeof init.body === 'string') {
      try {
        var b = JSON.parse(init.body);
        if (String(b.id || '').indexOf(BONUS_VARIANT + ':') === 0 && Number(b.quantity) === 0) sessionStorage.setItem(DECLINED_KEY, '1');
      } catch (e) {}
    }
    var p = origFetch(input, init);
    if (isCart) p.then(function () { setTimeout(reconcile, 60); }, function () {});
    return p;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcile);
  else reconcile();
})();
